import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { deepmerge } from 'deepmerge-ts'
import { forkJoin, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
declare const BUILD_TIME: string

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public prefix: string[] = ["assets/i18n/", "assets/i18n/kendo/"],
    public suffix: string = ".json"
  ) { }

  public getTranslation(lang: string): Observable<any> {
    const requests: Observable<Object | {}>[] = this.prefix.map(resource =>
      this.http.get(`${resource}${lang}.json?v=${BUILD_TIME}`)
    )

    return forkJoin(requests).pipe(map((response) => deepmerge(...response)))
  }
}
